<template>
    <div>
        <div class="ix-documents">
            <div class="ix-documents-header">
                <div class="ix-documents-header-left">
                    <span v-if="loading"><i class="far fa-circle-notch fa-spin"></i> Chargement des documents en cours</span>
                    <span v-if="!loading && rowsCount > 0">{{ rowsCount }} élément{{ rowsCount > 1 ? 's' : '' }}</span>
                </div>
                <div class="ix-documents-header-right">
                    <button class="ix-btn ix-btn-small blue" @click="openModal(true)" v-if="!readonly">
                        <i class="fas fa-folder"></i> {{ display == 'min' ? '+' : 'Nouveau dossier' }}
                    </button>

                    <button class="ix-btn ix-btn-small blue" @click="openModal(false)" v-if="!readonly">
                        <i class="far fa-file"></i> {{ display == 'min' ? '+' : 'Envoyer document' }}
                    </button>
                </div>
            </div>

            <table>
                <thead>
                    <tr v-if="node">
                        <td colspan="100%">
                            <a @click="changeNode(null)" class="ix-document-link">
                                <i class="far fa-home-lg-alt"></i>
                            </a>

                            <span v-for="(item, breadcrumbIndex) in breadcrumbs">
                                / <a @click="changeNode(item.id)" class="ix-document-link">{{ item.name }}</a>
                            </span>

                            / {{ node.name }}
                        </td>
                    </tr>
                    <tr>
                        <th v-if="linked">Origine</th>
                        <th class="ix-hover-cursor" @click="changeOrder('name')">
                            Nom
                            <i class="fas fa-caret-down" v-if="order == 'name'"></i>
                            <i class="fas fa-caret-up" v-if="order == '!name'"></i>
                        </th>
                        <th class="ix-hover-cursor" @click="changeOrder('size')" v-if="display != 'min'">
                            Poids
                            <i class="fas fa-caret-down" v-if="order == 'size'"></i>
                            <i class="fas fa-caret-up" v-if="order == '!size'"></i>
                        </th>
                        <th class="ix-hover-cursor" @click="changeOrder('updated_at')" v-if="display != 'min'">
                            Dernière modification
                            <i class="fas fa-caret-down" v-if="order == 'updated_at'"></i>
                            <i class="fas fa-caret-up" v-if="order == '!updated_at'"></i>
                        </th>
                        <th class="text-right" v-if="display != 'min'">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(folder, folderIndex) in folders">
                        <td v-if="linked">{{ originLabel }}</td>
                        <td :colspan="display != 'min' ? 3 : 1">
                            <i class="fas fa-folder" v-b-tooltip :title="'Par ' + folder.user.fullname"></i> <a
                                @click="changeNode(folder.id)" class="ix-document-link">{{ folder.name }}</a>
                        </td>
                        <td class="text-right" v-if="display != 'min'">
                            <div class="btn-group">
                                <button type="button" class="ix-btn-dropdown-actions" data-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false" data-boundary="viewport">
                                    <i class="far fa-ellipsis-h"></i>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right">
                                    <button class="ix-btn-dropdown-item" @click="changeNode(folder.id)"><i
                                            class="far fa-folder-open"></i> Accéder</button>
                                    <button class="ix-btn-dropdown-item" @click="trigerEditDocument(folder, folderIndex)"><i
                                            class="far fa-pen"></i> Modifier</button>
                                    <button class="ix-btn-dropdown-item danger" @click="deleteDocument(folder, folderIndex)"><i
                                            class="far fa-trash"></i> Supprimer</button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-for="(document, documentIndex) in documents">
                        <td v-if="linked">{{ originLabel }}</td>
                        <td>
                            <i class="far fa-file" v-b-tooltip :title="'Par ' + document.user.fullname"></i> <a
                                :href="document.document_path" target="_blank">
                                {{ document.name }}.{{ document.extension }}
                            </a>
                        </td>
                        <td v-if="display != 'min'">{{ document.size | formatFileSize }}</td>
                        <td v-if="display != 'min'">
                            <span class="ix-document-date">{{ document.updated_at | formatDate }}</span>
                        </td>
                        <td class="text-right" v-if="display != 'min'">
                            <div class="btn-group">
                                <button type="button" class="ix-btn-dropdown-actions" data-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false" data-boundary="viewport">
                                    <i class="far fa-ellipsis-h"></i>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right">
                                    <a :href="document.document_path" class="ix-btn-dropdown-item" target="_blank"><i
                                            class="far fa-search"></i> Ouvrir</a>
                                    <button class="ix-btn-dropdown-item" @click="trigerEditDocument(document, documentIndex)"><i
                                            class="far fa-pen"></i> Modifier</button>
                                    <button class="ix-btn-dropdown-item danger"
                                        @click="deleteDocument(document, documentIndex)"><i class="far fa-trash"></i>
                                        Supprimer</button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <!--
                        Documents des éléments liés : seuls le téléchargement et
                        la suppression sont proposés (aucune modification ni
                        déplacement depuis cet élément). Affichés uniquement à la
                        racine, ils n'appartiennent à aucun dossier de l'élément
                        courant.
                    -->
                    <tr v-for="linkedDocument in visibleLinkedDocuments" :key="'linked-' + linkedDocument.id">
                        <td>
                            <a v-if="linkedDocument.origin && linkedDocument.origin.url" :href="linkedDocument.origin.url">{{ linkedDocument.origin.reference }}</a>
                            <span v-else-if="linkedDocument.origin">{{ linkedDocument.origin.reference }}</span>
                        </td>
                        <td>
                            <i class="far fa-file" v-b-tooltip :title="'Par ' + linkedDocument.user.fullname"></i> <a
                                :href="linkedDocument.document_path" target="_blank">
                                {{ linkedDocument.name }}.{{ linkedDocument.extension }}
                            </a>
                        </td>
                        <td v-if="display != 'min'">{{ linkedDocument.size | formatFileSize }}</td>
                        <td v-if="display != 'min'">
                            <span class="ix-document-date">{{ linkedDocument.updated_at | formatDate }}</span>
                        </td>
                        <td class="text-right" v-if="display != 'min'">
                            <div class="btn-group">
                                <button type="button" class="ix-btn-dropdown-actions" data-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false" data-boundary="viewport">
                                    <i class="far fa-ellipsis-h"></i>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right">
                                    <a :href="linkedDocument.document_path" class="ix-btn-dropdown-item" target="_blank"><i
                                            class="far fa-arrow-to-bottom"></i> Télécharger</a>
                                    <button class="ix-btn-dropdown-item danger"
                                        @click="deleteLinkedDocument(linkedDocument)"><i class="far fa-trash"></i>
                                        Supprimer</button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="!loading && !loadingLinked && rowsCount == 0">
                        <td class="text-center" colspan="100%">Il n'y a pas encore de documents associés</td>
                    </tr>
                </tbody>
            </table>

            <documents-manager-modal :url="url" :rolesUrl="rolesUrl" :admin="admin" ref="documentsManagerModal"
                :documentable-id="documentableId" :documentable-type="documentableType" :node="this.node">
            </documents-manager-modal>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import DocumentsManagerModal from "./DocumentsManagerModal"

export default {
    name: "DocumentsManager",
    components: {
        DocumentsManagerModal,
    },
    props: {
        documentableType: String,
        documentableId: Number,
        admin: Number,
        display: String,
        readonly: String,
        url: "",
        rolesUrl: "",
        // Active l'affichage des documents liés et la colonne « Origine ».
        // Désactivé par défaut : les emplacements qui ne la transmettent pas
        // sont inchangés.
        linked: { type: Boolean, default: false },
        // Libellé de la colonne « Origine » pour les documents propres (ex. « Ce devis »)
        originLabel: { type: String, default: 'Cet élément' },
    },
    watch: {
        documentableId: async function () {
            if (this.documentableId) {
                await this.getData();
            }
        },
    },
    data() {
        return {
            nodeId: null,
            node: null,
            breadcrumbs: [],
            folders: [],
            documents: [],
            roles: [],
            keepPermissions: 1,
            loading: true,
            loadingRoles: false,
            loadingForm: false,
            document: null,
            order: 'name',
            is_admin: this.admin || false,
            errorMessage: null,
            linkedDocuments: [],
            loadingLinked: false,
        }
    },
    computed: {
        // Les documents liés ne sont affichés qu'à la racine de l'arborescence
        visibleLinkedDocuments() {
            return this.linked && !this.nodeId ? this.linkedDocuments : [];
        },
        rowsCount() {
            return this.folders.length + this.documents.length + this.visibleLinkedDocuments.length;
        },
    },
    methods: {
        openModal(isFolder) {
            this.$refs.documentsManagerModal.startDocumentModal(isFolder);
        },
        trigerEditDocument(document, index) {
            this.$refs.documentsManagerModal.editDocument(document);
        },
        changeNode(nodeId, isInit = false) {
            this.nodeId = nodeId

            if (isInit == false) {
                if (this.nodeId) {
                    history.pushState("", document.title, window.location.pathname + '?documentNode=' + this.nodeId);
                } else {
                    history.pushState("", document.title, window.location.pathname);
                }

            }

            this.getData()
        },
        changeOrder(order) {
            this.order = this.order == order ? ('!' + order) : order
            this.getData()

            if (this.linked) {
                this.getLinkedData()
            }
        },
        async getData() {
            this.loading = true;

            fetch(this.url + "?orderBy=" + this.order + "&documentable_type=" + this.documentableType + "&documentable_id=" + this.documentableId + "&node=" + (this.nodeId ? this.nodeId : ''), {
                ...{
                    method: 'GET'
                },
                ...this.getHttpJsonRequestHeaders()
            }).then((response) => {
                this.loading = false;
                if (response.status == 200) {
                    response.json().then((data) => {
                        this.folders = data.folders
                        this.documents = data.documents
                        this.breadcrumbs = data.breadcrumbs
                        this.node = data.node
                    })
                }
            }).catch(error => {
                this.loading = false;
                console.log(error)
            });
        },
        /**
         * Documents portés par les éléments liés.
         *
         * État et chargement séparés de la liste propre (les index utilisés par
         * la modification / suppression des documents propres ne sont pas
         * affectés). Le serveur résout lui-même les éléments liés à partir du
         * seul élément courant, applique les droits, le tri courant et renvoie
         * l'origine (référence + lien) de chaque document.
         */
        async getLinkedData() {
            this.loadingLinked = true;

            fetch(this.url + "?orderBy=" + this.order + "&documentable_type=" + this.documentableType + "&documentable_id=" + this.documentableId + "&linked=1", {
                ...{
                    method: 'GET'
                },
                ...this.getHttpJsonRequestHeaders()
            }).then((response) => {
                this.loadingLinked = false;
                if (response.status == 200) {
                    response.json().then((data) => {
                        this.linkedDocuments = data.documents
                    })
                }
            }).catch(error => {
                this.loadingLinked = false;
                console.log(error)
            });
        },
        /**
         * Suppression d'un document lié : même route DELETE (et donc mêmes
         * contrôles de droits) que pour un document propre. Le document est
         * supprimé de son élément d'origine.
         */
        async deleteLinkedDocument(linkedDocument) {
            const reference = linkedDocument.origin ? linkedDocument.origin.reference : 'un autre élément';

            this.$swal({
                title: "Supprimer ce document ?",
                text: "Ce document appartient à " + reference + ". Il sera supprimé de son élément d'origine.",
                icon: "warning",
                dangerMode: true,
                buttons: ["Annuler", "Supprimer"]
            }).then((willDo) => {
                if (willDo) {
                    this.loading = true;
                    fetch(this.url + "/" + linkedDocument.id, {
                        ...{
                            method: 'DELETE'
                        },
                        ...this.getHttpJsonRequestHeaders()
                    }).then((response) => {
                        if (response.ok) {
                            this.linkedDocuments = this.linkedDocuments.filter(item => item.id !== linkedDocument.id)
                        }
                        this.loading = false;
                    }).catch(error => {
                        this.loading = false;
                        console.log(error);
                    })
                }
            });
        },
        async deleteDocument(document, index) {
            this.$swal({
                title: "Êtes vous sûr ?",
                text: document.is_folder ? "L'ensemble des documents présents dans le dossier seront également supprimés" : "Le document sera définitivement supprimé",
                icon: "warning",
                dangerMode: true,
                buttons: ["Annuler", "Supprimer"]
            }).then((willDo) => {
                if (willDo) {
                    this.loading = true;
                    fetch(this.url + "/" + document.id, {
                        ...{
                            method: 'DELETE'
                        },
                        ...this.getHttpJsonRequestHeaders()
                    }).then(async (response) => {
                        if (document.is_folder) {
                            this.folders.splice(index, 1)
                        } else {
                            this.documents.splice(index, 1)
                        }

                        if (!response.ok) {
                            if (document.is_folder) {
                                this.folders.splice(index, 0, document)
                            } else {
                                this.documents.splice(index, 0, document)
                            }
                        }
                        this.loading = false;
                    }).catch(error => {
                        this.loading = false;
                        console.log(error);
                    })
                }
            });
        },
    },

    async mounted() {
        var node = this.searchInUrl('documentNode');
        this.changeNode(node, true)

        if (this.linked) {
            this.getLinkedData()
        }
    }

}
</script>
